import React from 'react';
import SEO from '@/components/SEO';

const ChatSupportPage: React.FC = () => {
  return (
    <>
      <SEO 
        title="Chat Support | Cause Connect"
        description="Enhance your nonprofit's communication with AI-powered chat support solutions."
      />
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Chat Support</h1>
        <div className="prose max-w-none">
          <p className="text-lg text-gray-700 mb-6">
            Our AI-powered chat support solution helps nonprofits provide efficient and responsive communication to their stakeholders.
          </p>
          {/* Add more content specific to chat support features */}
        </div>
      </div>
    </>
  );
};

export default ChatSupportPage;
